import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import ReactTable from "../table/ReactTable";
import ReactModal from "../componets/ReactModal";
import {
  CreateCustomer,
  defalutCustomerState,
  initializeCustomerState,
  UpdateCustomer,
} from "../modules/customer";
import { ReactTableStyle2 } from "../table/ReactTableStyle";
import Select from "react-select";

const Input = styled.input`
  flex: 1;
  height: 18px;
  padding: 6px 10px;
  font-size: 13px;
  border-radius: 1px;
  border: solid 1px #ebebeb;
  ::placeholder {
    color: #cbcbcb;
  }
`;
const Button = styled.button`
  ${(props) => (props.height ? `height: ${props.height}px;` : `height: 36px;`)}
  ${(props) => props.width && `width: ${props.width}px;`}
  ${(props) =>
    props.border ? `border: 1px solid ${props.border};` : `border: 0;`}
  white-space: nowrap;
  padding: 5px 10px;
  margin-left: 8px;
  ${(props) => (props.color ? `color: ${props.color};` : `color: 000230;`)}
  ${(props) =>
    props.backColor
      ? `background-color: ${props.backColor};`
      : `background-color: #fff;`}
  font-size: 13px;
  font-weight: 400;
  border-radius: 2px;
  cursor: pointer;
  float: right;
`;
const ContWrap = styled.div``;
const ContTitle = styled.div`
  ${(props) =>
    props.size ? `font-size: ${props.size}px;` : `font-size: 24px;`}
  color: #333333;
  font-weight: 400;
`;
const DivideWrap = styled.div`
  display: flex;
  padding: 10px;
  margin: 20px 0;
  border-top: 1px solid #cbcbcb;
  border-bottom: 1px solid #cbcbcb;
  > div {
    flex: 2;
  }
  > div:first-child {
    padding-right: 30px;
  }
`;
const TextField = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
  :first-child {
    margin: 0;
  }
  > span {
    font-size: 13px;
    color: #8785a8;
    font-weight: 400;
    ${(props) => props.labelWidth && `width: ${props.labelWidth}px`}
  }
`;
const TextFieldWithButton = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
  :first-child {
    margin: 0;
  }
  > span {
    font-size: 13px;
    color: #8785a8;
    font-weight: 400;
    ${(props) => props.labelWidth && `width: ${props.labelWidth}px`}
  }
`;

const SelectBox = styled(Select)`
  flex: 1;
  font-size: 13px;
  border-radius: 1px;
  border: solid 1px #ebebeb;
  ::placeholder {
    color: #cbcbcb;
  }
  .css-yk16xz-control {
    border: none;
  }
  .css-1wa3eu0-placeholder {
    color: #cbcbcb;
  }
  .css-4ljt47-MenuList > div {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #666666;
  }
  .css-1n7v3ny-option,
  .css-9gakcf-option {
    background-color: #f5f5ff;
    font-weight: 500 !important;
    color: #000230 !important;
  }
`;

const labelWidth = 120;
const insuranceInit = {
  name: "",
  start_date: "",
  status: "",
  payment: "",
};
const memberDataInit = {
  title: "",
  birthday: "",
  gender: "",
  phone: "",
  address: "",
  address_detail: "",
  latitude: "",
  longitude: "",
};
const columns = [
  {
    Header: "상품명",
    accessor: "name",
  },
  {
    Header: "가입날짜",
    accessor: "start_date",
  },
  {
    Header: "유지상태",
    accessor: "status",
  },
  {
    Header: "납입금액",
    accessor: "payment",
  },
];
const genderOption = [
  { label: "남성", value: "남성" },
  { label: "여성", value: "여성" },
];
const CreateMember = ({ history, location }) => {
  const { detailData, status } = useSelector(({ customer }) => {
    const { detailData, status } = customer;
    return {
      detailData,
      status,
    };
  }, shallowEqual);
  const [memberData, setMemberData] = useState(
    Object.keys(detailData).length > 0 ? detailData : memberDataInit
  );
  const [insurance, setInsurance] = useState([]);
  const [insuranceData, setInsuranceData] = useState(insuranceInit);
  const [modalIsOpen, setISOpen] = useState(false);
  const [mode, setMode] = useState("create");
  const dispatch = useDispatch();
  const openModal = () => {
    setISOpen(true);
  };
  const closeModal = () => {
    setISOpen(false);
  };
  const removeByIndexs = (array, indexs) =>
    array.filter((_, i) => !indexs.includes(i));
  const deleteRows = (selectedIDs) => {
    const newData = removeByIndexs(
      insurance,
      Object.keys(selectedIDs).map((x) => parseInt(x, 10))
    );
    setInsurance(newData);
  };

  const addInsurance = () => {
    const preData = [...insurance];
    preData.push(insuranceData);
    setInsurance(preData);
    setInsuranceData(insuranceInit);
    closeModal();
  };

  const handleMemberData = (e, b, c) => {
    setMemberData({
      ...memberData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectData = (option, target) => {
    setMemberData({
      ...memberData,
      [target.name]: option,
    });
  };
  const handleInsuranceData = (e) => {
    setInsuranceData({
      ...insuranceData,
      [e.target.name]: e.target.value,
    });
  };
  const CreateMember = () => {
    const params = {
      ...memberData,
      gender: memberData.gender.value,
      insurance: JSON.stringify(insurance),
    };
    if (!params.title) {
      alert("고객명을 입력해주세요");
    } else if (!params.address) {
      alert("주소를 입력해주세요");
    } else {
      dispatch(CreateCustomer(params));
    }
  };
  const UpdateMember = () => {
    const params = {
      ...memberData,
      gender: memberData.gender.value,
      insurance: JSON.stringify(insurance),
    };
    if (!params.title) {
      alert("고객명을 입력해주세요");
    } else if (!params.address) {
      alert("주소를 입력해주세요");
    } else {
      dispatch(UpdateCustomer(params)).then(() => {
        history.goBack();
      });
    }
  };
  useEffect(() => {
    if (status === "CREATED") {
      setMode("edit");
      setMemberData(detailData);
    }
  }, [status, detailData]);
  useEffect(() => {
    if (Object.keys(detailData).length > 0) {
      setInsurance(detailData.insurance);
      setMode("edit");
    }
    dispatch(
      initializeCustomerState({
        sliceStoreName: "status",
        defaultState: defalutCustomerState.status,
      })
    );
    return () => {
      dispatch(
        initializeCustomerState({
          sliceStoreName: "detailData",
          defaultState: defalutCustomerState.detailData,
        })
      );
    };
  }, [detailData, dispatch]);
  const searchBar = (setValue, selectedIDs) => {
    return (
      <ContTitle size={16}>
        고객정보 등록
        <Button
          width={96}
          height={26}
          backColor={"#000230"}
          color={"#fff"}
          onClick={openModal}
        >
          추가
        </Button>
        <Button
          width={96}
          height={26}
          backColor={"#e9e9ff"}
          onClick={() => {
            deleteRows(selectedIDs);
          }}
        >
          삭제
        </Button>
      </ContTitle>
    );
  };
  const searchAddress = () => {
    window.name = "parentForm";
    window.setChildValue = setChildValue;
    const openWin = window.open(
      `http://www.juso.go.kr/addrlink/addrLinkUrl.do?confmKey=U01TX0FVVEgyMDIzMDcxNzIwMDAxNDExMzkzNjg=&returnUrl=${window.location.origin}/api/address&resultType=4`,
      "childForm",
      "width=570, height=350"
    );
    window.openWin = openWin;
  };
  const setChildValue = (addr) => {
    setMemberData({
      ...memberData,
      address: addr.addr,
      address_detail: addr.addrDetail,
      latitude: addr.latitude,
      longitude: addr.longitude,
    });
  };
  return (
    <ContWrap>
      <ContTitle>
        {mode === "edit" ? "고객정보 수정" : "고객정보 등록"}
        {mode === "edit" ? (
          <Button
            width={108}
            backColor={"#000230"}
            color={"#fff"}
            onClick={UpdateMember}
          >
            수정
          </Button>
        ) : (
          <Button
            width={108}
            backColor={"#000230"}
            color={"#fff"}
            onClick={CreateMember}
          >
            등록
          </Button>
        )}
        <Button
          width={108}
          onClick={() => {
            history.goBack();
          }}
        >
          취소
        </Button>
      </ContTitle>
      <DivideWrap>
        <div>
          <TextField labelWidth={labelWidth}>
            <span>고객명*</span>
            <Input
              name="title"
              value={memberData.title}
              onChange={handleMemberData}
            />
          </TextField>
          <TextField labelWidth={labelWidth}>
            <span>생년월일</span>
            <Input
              name="birthday"
              value={memberData.birthday}
              onChange={handleMemberData}
            />
          </TextField>
          <TextField labelWidth={labelWidth}>
            <span>성별</span>
            <SelectBox
              options={genderOption}
              name="gender"
              placeholder="성별선택"
              value={memberData.gender}
              onChange={handleSelectData}
            />
          </TextField>
          <TextField labelWidth={labelWidth}>
            <span>휴대전화번호</span>
            <Input
              name="phone"
              value={memberData.phone}
              onChange={handleMemberData}
            />
          </TextField>
        </div>
        <div>
          <TextFieldWithButton labelWidth={labelWidth}>
            <span>주소*</span>
            <Input readOnly={true} onClick={searchAddress} />
            <Button
              backColor={"#7b79a2"}
              color={"#fff"}
              height={32}
              onClick={searchAddress}
            >
              우편번호검색
            </Button>
          </TextFieldWithButton>
          <TextField labelWidth={labelWidth}>
            <span></span>
            <Input
              name="address"
              readOnly={true}
              value={memberData.address}
              onClick={searchAddress}
            />
          </TextField>
          <TextField labelWidth={labelWidth}>
            <span></span>
            <Input
              name="address_detail"
              value={memberData.address_detail}
              onChange={handleMemberData}
              placeholder="상세주소를 입력하세요"
            />
          </TextField>
        </div>
      </DivideWrap>
      <ReactTableStyle2>
        <ReactTable
          columns={columns}
          data={insurance}
          searchBar={searchBar}
          onRowClick={() => {}}
        />
      </ReactTableStyle2>
      {modalIsOpen && (
        <ReactModal
          visible={modalIsOpen}
          title={"가입상품 추가"}
          maskClosable={true}
          onClose={closeModal}
          modalBtn={
            <>
              <Button
                width={108}
                height={36}
                border={"#000230"}
                onClick={closeModal}
              >
                취소
              </Button>
              <Button
                width={108}
                height={36}
                backColor={"#e9e9ff"}
                onClick={addInsurance}
              >
                등록
              </Button>
            </>
          }
        >
          <TextField labelWidth={labelWidth}>
            <span>상품명</span>
            <Input
              name="name"
              value={insuranceData.name}
              onChange={handleInsuranceData}
            />
          </TextField>
          <TextField labelWidth={labelWidth}>
            <span>가입날짜</span>
            <Input
              name="start_date"
              value={insuranceData.start_date}
              onChange={handleInsuranceData}
            />
          </TextField>
          <TextField labelWidth={labelWidth}>
            <span>유지상태</span>
            <Input
              name="status"
              value={insuranceData.status}
              onChange={handleInsuranceData}
            />
          </TextField>
          <TextField labelWidth={labelWidth}>
            <span>납입금액</span>
            <Input
              name="payment"
              value={insuranceData.payment}
              onChange={handleInsuranceData}
            />
          </TextField>
        </ReactModal>
      )}
    </ContWrap>
  );
};

export default CreateMember;
